import {
  DynamicZoneComponentDTO,
  StrapiDynamicZoneComponentDTO,
} from "@lib/strapi/dtos/core/dynamicZoneComponent.dto";
import {
  StrapiMarkdownSectionDTO,
  MarkdownSectionDTO,
} from "@lib/strapi/dtos/components/sections/markdownSection.dto";
import { parseStrapiContent } from "@lib/strapi/content";

export class MarkdownSectionService {
  static async fromStrapi(
    locale: string,
    strapiData?: StrapiMarkdownSectionDTO,
  ): Promise<MarkdownSectionDTO> {
    if (!strapiData) {
      return null;
    }
    const dto = new MarkdownSectionDTO();
    Object.assign(
      dto,
      await DynamicZoneComponentDTO.fromStrapi(locale, strapiData),
    );
    dto.content = await parseStrapiContent(strapiData.content);
    return dto;
  }
}
